// TODO: Remove this hook after the July production release.
export const useDashboardNewUX = () => {
  return true;
};
